import { useEffect } from "react";
import { SITE } from "@/lib/site";

const organization = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.brand,
  legalName: SITE.legalName,
  url: SITE.website,
  email: SITE.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: SITE.address.line1,
    addressLocality: SITE.address.city,
    addressRegion: SITE.address.state,
    postalCode: SITE.address.postalCode,
    addressCountry: "US",
  },
  sameAs: [SITE.amazonStore],
};

export const StructuredData = () => {
  useEffect(() => {
    const id = "organization-jsonld";
    let script = document.getElementById(id);
    if (!script) {
      script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(organization);
  }, []);

  return null;
};

export default StructuredData;
